export default __webpack_public_path__ + "e5ecccd6ec0befe516cdfa4b17635c42.png";